import { useEffect, useState } from 'react';
import { employeesApi } from '@/api';
import { PageHeader } from '@/components/layout/PageHeader';
import { DataTable, type Column } from '@/components/ui/DataTable';
import type { EmployeeResponse } from '@/types/employee';
import { showApiError } from '@/utils/apiError';

export function SocialTeamsPage() {
  const [employees, setEmployees] = useState<EmployeeResponse[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    employeesApi
      .list({ page: 0, size: 200 })
      .then((r) => setEmployees(r.content))
      .catch((err) => showApiError(err, 'Failed to load team'))
      .finally(() => setLoading(false));
  }, []);

  const columns: Column<EmployeeResponse>[] = [
    {
      key: 'name',
      header: 'Team member',
      render: (e) => `${e.firstName} ${e.lastName}`,
    },
    { key: 'email', header: 'Email', render: (e) => e.email ?? '—' },
    { key: 'role', header: 'Role', render: (e) => e.roleName ?? '—' },
    {
      key: 'social',
      header: 'Social permissions',
      render: () => 'Inbox · Publish · Analytics (via org roles)',
    },
  ];

  return (
    <div>
      <PageHeader
        title="Social Teams"
        description="Assign conversations and moderate content by team member"
        breadcrumbs={[{ label: 'Social', to: '/social' }, { label: 'Teams' }]}
      />
      <p className="mb-4 text-sm text-slate-600 dark:text-slate-400">
        Assignment is available in Unified Inbox and platform inboxes. Manage roles under Organization → Users.
      </p>
      <DataTable columns={columns} data={employees} loading={loading} keyField="id" />
    </div>
  );
}
